import { createContext } from 'react'

import {
  IData_MagicTag_Render_Values,
} from '@kaidam/fc-shared/src/types/schema/magic_tag'

export interface IData_LayoutForm_Context {
  renderValues: IData_MagicTag_Render_Values
}

const LayoutFormContext = createContext<IData_LayoutForm_Context>({
  renderValues: {},
})

export default LayoutFormContext